import { DashboardService } from './../../dashboard.service';
import { Component, Input, OnInit } from '@angular/core';
import { Parameter } from 'src/app/apps/dashboard/dashboard';

@Component({
  selector: 'app-param-select',
  templateUrl: './param-select.component.html',
  styleUrls: ['./param-select.component.less'],
})
export class ParamSelectComponent implements OnInit {
  @Input() parameter: Parameter;
  options: any;
  isLoading = false;
  @Input() dashboardParams: string[];
  @Input() dashboardParamNames: string[];
  @Input() dashboardId: number;

  constructor(private dashboardService: DashboardService) {}

  ngOnInit(): void {}

  getOptions() {
    this.isLoading = true;
    const paramsNames: string[] = [];
    const vals: string[] = [];

    this.dashboardService
      .getSelectValues(0, this.parameter.SQLStatementId, paramsNames, vals)
      .subscribe((d: any) => {
        this.options = d.Values.rowsArray;
        this.isLoading = false;
      });
  }

  valueChanged($event) {
    console.log($event);
    console.log(this.dashboardParams);

    this.dashboardService.triggerParameterValueChanged({
      dashboardId: this.dashboardId,
      dashboardParams: this.dashboardParams,
      dashboardParamNames: this.dashboardParamNames
    });
  }
}
